import { ref, computed, reactive } from 'vue'
import { defineStore } from 'pinia'
import { OnBoarding } from '@/types/Onboarding'
import { meInfo } from '@/services/mentor/Mentor'
type USERDATA = {
  name: string
  surname: string
  email: string
  profilePhotoUrl: string
  birthdate: string // veya Date
  universityName: string
  departmentName: string
  yksRank: number
  status: string
  id: string
  mobile?: string
  userType?: string
}
export const useUserStore = defineStore(
  'user',
  () => {
    const tokens = ref({
      accessToken: '',
      refreshToken: '',
      accessTokenExpiration: '',
      refreshTokenExpiration: ''
    })
    const onBoarding = ref<OnBoarding>({
      step1: {},
      step2: {},
      step3: {},
      step4: {},
      step5: {}
    })
    const userData = ref<USERDATA>({
      name: '',
      surname: '',
      email: '',
      status: '',
      profilePhotoUrl: '',
      birthdate: '',
      universityName: '',
      departmentName: '',
      yksRank: 0,
      id: ''
    })
    const deneme = ref('deneme')
    const getTokens = computed(() => tokens)
    const getUserData = computed(() => userData)
    const getOnboardingData = computed(() => onBoarding)
    const SET_TOKENS = (par: {
      accessToken: string
      refreshToken: string
      accessTokenExpiration: string
      refreshTokenExpiration: string
    }) => {
      tokens.value = par
    }
    const SET_ONBOARDING = (par: any) => {
      onBoarding.value = {
        ...onBoarding.value,
        ...par
      }
    }

    const SET_USER_DATA = (par: USERDATA) => {
      userData.value = par
    }
    const fetchNewUserData = async () => {
      try {
        const response = await meInfo()
        SET_USER_DATA(response.data)
      } catch (e) {
        console.log(e)
      }
    }
    return {
      tokens,
      deneme,
      SET_TOKENS,
      getTokens,
      SET_ONBOARDING,
      onBoarding,
      getOnboardingData,
      SET_USER_DATA,
      getUserData,
      fetchNewUserData
    }
  },
  {
    persist: [
      {
        paths: ['tokens'],
        storage: localStorage
      }
    ]
  }
)
